import { __assign } from "tslib";
import { RandomGenerator } from '../test-utils';
var DocMetadataBuilder = /** @class */ (function () {
    function DocMetadataBuilder() {
        this.docMetadata = {
            metadata: {
                articleId: RandomGenerator.id(),
                articleTitle: 'Japanese - Policy & Abuse',
                articleType: 100,
                origContent: '',
                product: 'UNKNOWN',
                sourceId: 'd1a6cfec-a681-4fda-9151-3dd6c56700bd',
                url: 'https://csadvbilling.wixanswers.com/en/article/japanese-policy-abuse',
            },
            distance: 0.22331472913202388,
        };
    }
    DocMetadataBuilder.prototype.withMetadata = function (partialMetadata) {
        this.docMetadata.metadata = __assign(__assign({}, this.docMetadata.metadata), partialMetadata);
        return this;
    };
    DocMetadataBuilder.prototype.withDistance = function (distance) {
        this.docMetadata.distance = distance;
        return this;
    };
    DocMetadataBuilder.prototype.build = function () {
        return this.docMetadata;
    };
    return DocMetadataBuilder;
}());
export { DocMetadataBuilder };
//# sourceMappingURL=doc-metadata.builder.js.map